import { contentTiles, tokenGeneration } from './content-tiles-en.i18n';

export const en = {
  contentTiles,
  tokenGeneration,
};
